import FavouriteIcon from "../../../../../../../assets/svg/favourite-icon";
import FavouriteFilledIcon from "../../../../../../../assets/svg/favourite-filled-icon";
import {
  useAddCampaignTemplateFavoriteMutation,
  useRemoveCampaignTemplateFavoriteMutation,
} from "../../../../../../../redux/services/campaignApi";
import { customToast } from "../../../../../../../utils/custom-toast/custom-toast";
import { TemplateTableData } from "../../../utils/types";

const TemplateFavoriteButton = ({
  rowData,
}: {
  rowData: TemplateTableData;
}) => {
  const isFavorite = Boolean(rowData.is_favorite);

  const [addFavorite, { isLoading: isAdding }] =
    useAddCampaignTemplateFavoriteMutation();
  const [removeFavorite, { isLoading: isRemoving }] =
    useRemoveCampaignTemplateFavoriteMutation();

  const isTogglingFavorite = isAdding || isRemoving;

  const handleToggleFavorite = async (event: React.MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();

    try {
      if (isFavorite) {
        await removeFavorite(rowData.id).unwrap();
        customToast("Template removed from favorites", "success");
      } else {
        await addFavorite(rowData.id).unwrap();
        customToast("Template marked as favorite", "success");
      }
    } catch {
      customToast(
        isFavorite
          ? "Failed to remove template from favorites"
          : "Failed to mark template as favorite",
        "error"
      );
    }
  };

  return (
    <button
      type="button"
      onClick={handleToggleFavorite}
      disabled={isTogglingFavorite}
      aria-pressed={isFavorite}
      aria-label={isFavorite ? "Remove from favorites" : "Add to favorites"}
      className={`flex shrink-0 items-center justify-center w-5 h-5 rounded-[6px] border transition-all duration-200 disabled:cursor-not-allowed ${
        isFavorite
          ? "opacity-100 bg-card-yellow-bg dark:bg-card-yellow-bg-dk border-card-yellow-stroke dark:border-card-yellow-stroke-dk"
          : "opacity-0 group-hover/row:opacity-100 focus-visible:opacity-100 bg-pure-white dark:bg-pure-white-dk hover:bg-hover-effect dark:hover:bg-hover-effect-dk border-border-gray dark:border-border-gray-dk"
      }`}
    >
      {isFavorite ? (
        <FavouriteFilledIcon className="w-[13px] h-[13px] text-rating-yellow dark:text-rating-yellow-dk" />
      ) : (
        <FavouriteIcon className="w-[13px] h-[13px] text-gray-placeholder dark:text-gray-placeholder-dk" />
      )}
    </button>
  );
};

export default TemplateFavoriteButton;
